import { useContext } from 'react';
import { AbilityContext } from '../users/UseUserPermissions';

/**
 * useCanChangeReviewStatus - CASL gate for toggling a task's review status.
 *
 * Same `manage:notes` (Full Access) permission that controls note creation.
 */
export const useCanChangeReviewStatus = (): boolean => {
  const ctx = useContext(AbilityContext);

  return ctx?.permissions?.can('manage', 'notes') ?? false;
};
